/* Identicon component */

import {CSSProperties, MouseEventHandler} from 'react';
import font from 'Style/font';
import color from '../../../color';
import border from 'Style/border';

function getStyle() {
  const container = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...border().circle,
    cursor: 'pointer',
  };
  const initial = {
    fontFamily: font.family.sans,
  };
  const hashChars =
    'abcdefghijklmnopqrstuvwxyz' + 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + '0123456789'; // 62 chars
  return {
    getContainerStyle(
      hash: string,
      width: number,
      height: number,
      hover: boolean,
    ) {
      // Takes the 1st 2 chars of hash and generates a hue value:
      const colorHue = Math.floor(
        ((hashChars.indexOf(hash.substr(0, 1)) + 1) *
          (hashChars.indexOf(hash.substr(1, 1)) + 1) *
          360) /
          (62 * 62),
      );

      return {
        ...container,
        backgroundColor: `hsl(${colorHue}, 80%, 60%)`,
        width: `${width}px`,
        height: `${height}px`,
        border: hover ? `1px solid ${color.hover}` : `1px solid ${color.white}`,
      };
    },
    getInitialStyle() {
      return {
        ...initial,
        fontSize: font.size.body,
        color: color.white,
      };
    },
  };
}

type Props = {
  width: number;
  height: number;
  extraStyle: CSSProperties;
  hash: string;
  name: string;
  hover: boolean;
  title: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
};

const Identicon = ({
  name,
  hash,
  width,
  height,
  extraStyle,
  onClick,
  hover,
}: Props): JSX.Element => {
  const containerStyle = {
    ...getStyle().getContainerStyle(hash, width, height, hover),
    ...extraStyle,
  };
  const initial = name.substr(0, 1).toUpperCase();
  const initialStyle = getStyle().getInitialStyle();
  return (
    <div style={containerStyle} title={name} onClick={onClick}>
      <span style={initialStyle}>{initial}</span>
    </div>
  );
};

export default Identicon;
